/**
 * Where each answer lands on the printed sheet, so the preview can follow the
 * field being typed into.
 *
 * A long form is taller than its preview card: type into item ৩২ and the line
 * you are filling is two screens down, which makes the live preview useless for
 * exactly the fields that most need checking. The page maps a field key to the
 * baseline that prints it, and the rail scrolls there when the field takes
 * focus.
 *
 * @param {{ rows: Array, combs: Array }[]} pages One entry per printed page.
 * @returns {Record<string, { page: number, y: number }>}
 */
export function buildFieldAnchors(pages) {
    const anchors = {};
    pages.forEach(({ rows = [], combs = [] }, page) => {
        for (const row of rows) {
            // The first place a field prints wins: a name that also appears on a
            // tear-off slip should scroll to the question, not the receipt.
            if (row.value && !(row.value in anchors)) anchors[row.value] = { page, y: row.y };
        }
        for (const comb of combs) {
            if (comb.value && !(comb.value in anchors)) {
                anchors[comb.value] = { page, y: comb.top + comb.height };
            }
        }
    });
    return anchors;
}

/**
 * Scroll a preview's scroll box so the given anchor sits a little above the
 * middle of the card — high enough to read the line and what follows it.
 *
 * @param {HTMLElement} el The scroll box.
 * @param {{ page: number, y: number }} anchor
 * @param {{ scale: number, pageHeight: number, pageGap: number, pad: number }} view
 */
export function scrollToAnchor(el, anchor, { scale, pageHeight, pageGap, pad }) {
    if (!el || !anchor) return;
    const y = (anchor.page * (pageHeight + pageGap) + anchor.y) * scale + pad;
    const top = Math.max(0, Math.min(y - el.clientHeight * 0.42, el.scrollHeight - el.clientHeight));
    el.scrollTo({ top, behavior: 'smooth' });
}
